import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-datepicker', 'chooseDate', 'Vali kuupäev');
Labels.set('ui-datepicker', 'selectedDate', 'Valitud kuupäev');
Labels.set('ui-datepicker', 'close', 'Kinni');
Labels.set('ui-datepicker', 'clear', 'Puhasta väli');
